/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RateInfoRespVo } from './RateInfoRespVo';
import {
    RateInfoRespVoFromJSON,
    RateInfoRespVoFromJSONTyped,
    RateInfoRespVoToJSON,
    RateInfoRespVoToJSONTyped,
} from './RateInfoRespVo';
import type { SystemExchangeRateRespVo } from './SystemExchangeRateRespVo';
import {
    SystemExchangeRateRespVoFromJSON,
    SystemExchangeRateRespVoFromJSONTyped,
    SystemExchangeRateRespVoToJSON,
    SystemExchangeRateRespVoToJSONTyped,
} from './SystemExchangeRateRespVo';

/**
 * 
 * @export
 * @interface RateEchoRespVo
 */
export interface RateEchoRespVo {
    /**
     * 
     * @type {RateInfoRespVo}
     * @memberof RateEchoRespVo
     */
    chinaRate?: RateInfoRespVo;
    /**
     * 
     * @type {RateInfoRespVo}
     * @memberof RateEchoRespVo
     */
    koreaRate?: RateInfoRespVo;
    /**
     * 
     * @type {SystemExchangeRateRespVo}
     * @memberof RateEchoRespVo
     */
    ttRate?: SystemExchangeRateRespVo;
}

/**
 * Check if a given object implements the RateEchoRespVo interface.
 */
export function instanceOfRateEchoRespVo(value: object): value is RateEchoRespVo {
    return true;
}

export function RateEchoRespVoFromJSON(json: any): RateEchoRespVo {
    return RateEchoRespVoFromJSONTyped(json, false);
}

export function RateEchoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RateEchoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'chinaRate': json['chinaRate'] == null ? undefined : RateInfoRespVoFromJSON(json['chinaRate']),
        'koreaRate': json['koreaRate'] == null ? undefined : RateInfoRespVoFromJSON(json['koreaRate']),
        'ttRate': json['ttRate'] == null ? undefined : SystemExchangeRateRespVoFromJSON(json['ttRate']),
    };
}

export function RateEchoRespVoToJSON(json: any): RateEchoRespVo {
    return RateEchoRespVoToJSONTyped(json, false);
}

export function RateEchoRespVoToJSONTyped(value?: RateEchoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'chinaRate': RateInfoRespVoToJSON(value['chinaRate']),
        'koreaRate': RateInfoRespVoToJSON(value['koreaRate']),
        'ttRate': SystemExchangeRateRespVoToJSON(value['ttRate']),
    };
}

